import { render, staticRenderFns } from "./DefRegisterModal.vue?vue&type=template&id=d41573c8&"
import script from "./DefRegisterModal.vue?vue&type=script&lang=js&"
export * from "./DefRegisterModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports